var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"car-detail-container"},[_c('h6',{staticClass:"font-weight-bold"},[_c('img',{attrs:{"src":require("@/assets/fa/car-icon.svg"),"alt":""}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }